import { injectTranslate } from '@recruitee/i18n';
import { textCellFactory } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const qualifiedCountColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.QualifiedCount,
  label: injectTranslate()('app.offers.table.qualified'),
  visible: false,
  geometry: {
    width: 120,
    minWidth: 120,
    maxWidth: 140,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('qualifiedCandidatesCount'),
}));
